module.exports = __webpack_public_path__ + "static/media/user-icon.e7e1ce64.png";